import { fetchReducerFactory, failed, succeeded } from '../../../shared/store/fetchFactory';

import initialState from './initialState';
import {
  FETCH_SCENARIOS,
  SET_SELECTED_COMPARE_SCENARIO,
  SET_SELECTED_SCENARIO_VIEW,
  SET_SELECTED_SCENARIO_EDIT_CY,
  SET_SELECTED_SCENARIO_CURRENCY,
  CALCULATE_SCENARIO,

  FETCH_SCENARIO_REPORT_DATA,
  FETCH_SCENARIO_REPORT_FIELDS,
  CLEAR_SCENARIO_REPORT_DATA,

  UPLOAD_TAGGED_DATA_FILE,
  CLEAR_UPLOAD_TAGGED_DATA_ERRORS,

  FETCH_ALLOWED_PERIODS_FOR_SCENARIOS,
} from './types';


const fetchReducer = fetchReducerFactory({
  [FETCH_SCENARIOS]: 'Scenarios',
  [FETCH_ALLOWED_PERIODS_FOR_SCENARIOS]: 'ScenarioAllowedPeriods',
  [CALCULATE_SCENARIO]: 'CalculatingScenario',
  [FETCH_SCENARIO_REPORT_DATA]: 'ReportData',
  [FETCH_SCENARIO_REPORT_FIELDS]: 'ReportFields',
}, initialState);

const scenariosSharedReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_COMPARE_SCENARIO: {
      return ({
        ...state,
        selectedScenarioToCompare: action.scenario,
      });
    }
    case SET_SELECTED_SCENARIO_VIEW: {
      return ({
        ...state,
        selectedView: action.view,
      });
    }
    case SET_SELECTED_SCENARIO_EDIT_CY: {
      return ({
        ...state,
        selectedEditCY: action.editCy,
      });
    }
    case SET_SELECTED_SCENARIO_CURRENCY: {
      return ({
        ...state,
        selectedCurrency: action.currency,
      });
    }
    case CLEAR_SCENARIO_REPORT_DATA: {
      return ({
        ...state,
        reportsData: initialState.reportsData,
      });
    }
    case UPLOAD_TAGGED_DATA_FILE: {
      return ({
        ...state,
        isLoadingUploadTaggedData: true,
        uploadTaggedDataErrors: initialState.uploadTaggedDataErrors,
      });
    }
    case succeeded(UPLOAD_TAGGED_DATA_FILE): {
      return ({
        ...state,
        isLoadingUploadTaggedData: false,
      });
    }
    case failed(UPLOAD_TAGGED_DATA_FILE): {
      return ({
        ...state,
        isLoadingUploadTaggedData: false,
        uploadTaggedDataErrors: action.errors || [],
      });
    }
    case CLEAR_UPLOAD_TAGGED_DATA_ERRORS: {
      return ({
        ...state,
        uploadTaggedDataErrors: initialState.uploadTaggedDataErrors,
      });
    }
    default: {
      return fetchReducer(state, action);
    }
  }
};

export default scenariosSharedReducer;
